module.exports = __webpack_public_path__ + "static/media/DiamondIcon.2244e324.svg";